import { useFeatureFlags } from '@audibene/ta.react-feature-flags'

type FeatureFlagName =
  | 'ADD_APPOINTMENT_NOTES_TIMELINE_V2'
  | 'APP_INSTALLATION_STATUS'
  | 'APPOINTMENT_GUIDES'
  | 'APPOINTMENT_DASHBOARD_V2'
  | 'APPOINTMENT_TRANSCRIPT_SCORING'
  | 'CARE_MACHINE_TAB'
  | 'COMPLETE_APPOINTMENT_OUTCOME'
  | 'DASHBOARD_FOCUS_CUSTOMERS'
  | 'DASHBOARD_JOIN_CALL_BUTTON'
  | 'DASHBOARD_POOLED_APPOINTMENTS'
  | 'DASHBOARD_RESCHEDULE_BUTTON'
  | 'DEVICES_TAB'
  | 'DISPLAY_CUSTOMER_PROFILE_CLIENT'
  | 'DISPLAY_DOCUMENT_CLIENT'
  | 'DISPLAY_HEARING_TEST_CLIENT'
  | 'DISPLAY_MEDIA_ITEM_DATES'
  | 'DISPLAY_OPPORTUNITY_INFO_SECTION'
  | 'DISPLAY_WEARING_TIME_FOCUS_REASON'
  | 'EDIT_NOTES_TIMELINE_V2'
  | 'EXPORT_AUDIOGRAM'
  | 'FITTING_QUALITY_SCORE'
  | 'FLOW_CLIENT_VNEXT'
  | 'HIDE_NOTIFICATIONS_FEED'
  | 'INSURANCE_PROFILE_DOWNLOAD'
  | 'NOTES_TIMELINE_V2'
  | 'ORDER_TAB_CANCEL_ORDERS'
  | 'CUSTOMER_DETAILS_OTOSCOPY_TAB'
  | 'PROGRESS_BAR_V2'
  | 'SALES_ORDER_FORM'
  | 'SCHEDULE_APPOINTMENT'
  | 'SETTINGS_PAGES'
  | 'SHOULD_USE_DEVICE_SERVICE'
  | 'SHOW_AI_SUMMARY_ATTRIBUTION'
  | 'SHOW_RETAIL_CUSTOMER_BADGE'
  | 'TEST_FEATURE_FLAGS'
  | 'TIMELINE_RESCHEDULE_BUTTON'
  | 'NEO'
  | 'LIVE_CHAT'
  | 'TA_CHAT_CLIENT'
  | 'NEO_HEALTH_INSURANCE_FORM'
  | 'NEO_APPOINTMENT_FORM'
  | 'NEO_NEW_APPOINTMENT_FEEDBACK'
  | 'NEO_PRICE_LIST'
  | 'NEW_CUSTOMER_PIPELINE'
  | 'NOTES_INTERACTION'

type Uuid = `${string}-${string}-${string}-${string}-${string}`

// Feature flag key values can be found here: https://app.launchdarkly.com/ta-team-america/production/features
const featureFlagNameToKeyMap: Record<FeatureFlagName, Uuid> = {
  ADD_APPOINTMENT_NOTES_TIMELINE_V2: '53d2e905-3903-4c37-94f8-7a60c17500e7',
  APP_INSTALLATION_STATUS: 'f85c771e-bc70-48d6-bad0-51bf463980e4',
  APPOINTMENT_DASHBOARD_V2: 'fa55ec74-e233-48e8-86ac-ebe155edfb09',
  APPOINTMENT_GUIDES: '5f0c8a3e-2b7d-4e19-9c61-a4d3e8b27f05',
  APPOINTMENT_TRANSCRIPT_SCORING: '0df4d0a2-9861-4030-9147-96eb778fc96d',
  CARE_MACHINE_TAB: 'bebc5542-aa58-43a6-b5f1-eb77c8fcbcf1',
  COMPLETE_APPOINTMENT_OUTCOME: '77adc110-f644-4571-871f-400bd2b7c907',
  CUSTOMER_DETAILS_OTOSCOPY_TAB: '3490ba61-1fc8-416e-9b29-1b1856282b51',
  DASHBOARD_FOCUS_CUSTOMERS: '21fcbd40-fbdf-4661-9465-e123d5781398',
  DASHBOARD_JOIN_CALL_BUTTON: '0a6895c5-2c2e-47af-8452-2a3b614bbd85',
  DASHBOARD_POOLED_APPOINTMENTS: '9501058d-7e07-4ec7-9c8b-2487b327344b',
  DASHBOARD_RESCHEDULE_BUTTON: '5b156c42-8594-43fb-be56-313cad3dd1d5',
  DEVICES_TAB: '3c292c94-47c0-45a0-aa88-0c15fec4ce66',
  DISPLAY_CUSTOMER_PROFILE_CLIENT: '556a6609-3334-45f5-a586-ff976bacc17d',
  DISPLAY_DOCUMENT_CLIENT: '57007004-40af-43bc-8720-a074ecfeadb9',
  DISPLAY_HEARING_TEST_CLIENT: 'e3c94109-0eeb-4091-bd66-c36a263e6030',
  DISPLAY_MEDIA_ITEM_DATES: '8b0fd031-c74c-4f40-894f-21109c5748ee',
  DISPLAY_OPPORTUNITY_INFO_SECTION: 'c1be3591-c966-453e-abae-db5151d5c23d',
  DISPLAY_WEARING_TIME_FOCUS_REASON: '35ce4d74-204b-4aa7-a346-ff4509fd7e96',
  EDIT_NOTES_TIMELINE_V2: '5da234f7-3ab4-435e-b9bb-a23d3e4c6c40',
  EXPORT_AUDIOGRAM: 'ffad2030-19fe-4cb4-a92e-6ba6cbb00efb',
  FITTING_QUALITY_SCORE: '1c4dbc72-93e9-4945-9188-12e99f190aa3',
  FLOW_CLIENT_VNEXT: '3f1bd6aa-cd0a-4095-8b25-4a8abff469b5',
  HIDE_NOTIFICATIONS_FEED: 'b9364502-d567-4991-9c12-78d6a2dcedc2',
  INSURANCE_PROFILE_DOWNLOAD: '89cce9ea-dd48-4264-a4da-4bce54a7a177',
  LIVE_CHAT: '896dabeb-cf48-4caa-a93a-316643de811f',
  NEO: 'd6d03fe4-4b4e-4535-92d6-2b1ba8ebce1e',
  NEO_APPOINTMENT_FORM: 'a2ace749-2e07-4718-93ea-005bd191eb87',
  NEO_HEALTH_INSURANCE_FORM: '7b893866-092d-420a-9583-2690a5394efc',
  NEO_NEW_APPOINTMENT_FEEDBACK: '22927cf4-4827-4b2a-8dc4-7fd1042f73ae',
  NEO_PRICE_LIST: '9ee1681b-f1c5-4ac1-a095-967fe5047f6d',
  NEW_CUSTOMER_PIPELINE: '1875aa74-1421-4f5b-8a74-d49e7a55c14b',
  NOTES_INTERACTION: 'e9aea4f8-9bdd-4728-8f0d-e2c136131a2b',
  NOTES_TIMELINE_V2: 'e9798c8b-94b9-42d0-b25e-b350c7c8838b',
  ORDER_TAB_CANCEL_ORDERS: '6c6a226e-6795-487d-bc84-bbe0fc70270d',
  PROGRESS_BAR_V2: 'bb7d0919-7a64-4036-9042-f189575b8f91',
  SALES_ORDER_FORM: 'cf9df706-292f-45fa-ad68-52a95875a8bc',
  SCHEDULE_APPOINTMENT: 'abe7ab80-cb4e-4a9a-84d2-12124867693e',
  SETTINGS_PAGES: '80a25283-a827-45a1-99d4-e12ca6809e90',
  SHOULD_USE_DEVICE_SERVICE: '7c5dabbd-2df7-4239-aea1-4a9865596cf3',
  SHOW_AI_SUMMARY_ATTRIBUTION: 'ade703d6-5140-4ff6-b806-cf1181b9bd19',
  SHOW_RETAIL_CUSTOMER_BADGE: '1d4d3ab1-f0fe-4c1d-8854-2a5840de6fb7',
  TA_CHAT_CLIENT: '37f26f16-5c7b-4c0c-9af8-e9263432e396',
  TEST_FEATURE_FLAGS: '3b35dc23-6f42-4d00-8848-455e4ebf7bff',
  TIMELINE_RESCHEDULE_BUTTON: 'f218a508-22b4-4c9b-9b78-301f5e7fee5e',
} as const

export { featureFlagNameToKeyMap, useFeatureFlags }
export type { FeatureFlagName }
